import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useLightboxStore = defineStore('lightbox', () => {
  // --- State ---
  const showLightbox = ref(false);
  const lightboxImages = ref([]);
  const lightboxCurrentIndex = ref(0);
  const prevFocusedElem = ref(null);

  // --- Actions ---
  function openLightbox() {
    showLightbox.value = true;
  }
  function closeLightbox() {
    showLightbox.value = false;
  }
  function setLightboxImages(payload) {
    lightboxImages.value = payload;
  }
  function setLightBoxCurrentIndex(payload) {
    lightboxCurrentIndex.value = payload;
  }
  function setPrevFocusedElem(payload) {
    prevFocusedElem.value = payload;
  }

  return {
    showLightbox,
    lightboxImages,
    lightboxCurrentIndex,
    prevFocusedElem,
    openLightbox,
    closeLightbox,
    setLightboxImages,
    setLightBoxCurrentIndex,
    setPrevFocusedElem,
  };
});
